import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { browserHistory } from 'react-router'
import { getProposal } from '../../user/actions/proposal/GetProposal'
import { connect } from 'react-redux'
import {
  Segment
} from 'semantic-ui-react'
import lightwallet from 'eth-lightwallet'

import ProposalIsExecuted from './components/ProposalIsExecuted';
import NoMoreThanYes from './components/NoMoreThanYes';
import NotEnoughVotes from './components/NotEnoughVotes';
import NotEnoughBudget from './components/NotEnoughBudget';
import NoTokenProposalDeadline from './components/NoTokenProposalDeadline';
import NoTokenProposal from './components/NoTokenProposal';
import ProposalIsVoted from './components/ProposalIsVoted';
import ProposalExecute from './components/ProposalExecute';
import ProposalVote from './components/ProposalVote';

class Proposal extends Component {
	
    constructor(props) {
        super(props)

        this.state = {
            proposalLoading: true
        }

    }
	
    componentWillMount(){
		
        let { dispatch, authData, params, memberId, balanceIn, proposalId } = this.props

        if(memberId === '0' || balanceIn === '0 ETH'){
            return browserHistory.push('/city')
        }

        if (params.id === proposalId.toString()){
            this.setState({proposalLoading: false})
        }

        let ks = lightwallet.keystore.deserialize(authData.keystore)
        let address = ks.getAddresses()
		
        dispatch(getProposal(address[0], params.id))
		
    }

    componentWillReceiveProps(nextProps){

        let { params } = this.props

        let { proposalId  } = nextProps
  
        if (params.id === proposalId.toString()){
            this.setState({proposalLoading: false})
        }

    }
	
    render() {

        let { proposalLoading } = this.state

        let { memberId, balanceIn, balanceInToken, isExecuted, isDeadlineOver, voteYes, voteNo, allVotes, minimumVotes, enoughBudget, isVoted, authData, params } = this.props

        if(memberId === 'N-N' || balanceIn === 'N-N' || balanceInToken === 'N-N' || proposalLoading){
            return(<Segment style={{  minHeight: 700 }} vertical loading />)
        }

        if(memberId !== '0' || balanceIn !== '0 ETH'){

            if(isExecuted){

                return <ProposalIsExecuted/>
                
            } else {

                if(isDeadlineOver){

                    if(voteYes <= voteNo){

                        return <NoMoreThanYes/>
                        
                    } else {

                        if(allVotes < minimumVotes){

                            return <NotEnoughVotes/>

                        } else {

                            if(enoughBudget){

                                if(balanceInToken !== '0 ETH'){

                                    return <ProposalExecute authData={authData} params={params} />

                                } else {

                                    return <NoTokenProposalDeadline />
                                }
                            } else {
                                
                                return <NotEnoughBudget />
                            }
                        }
                    }
                } else {

                    if(isVoted){

                        return <ProposalIsVoted />

                    } else {

                        if(balanceInToken !== '0 ETH'){
                            
                            return <ProposalVote authData={authData} params={params} />
                        } else {

                            return <NoTokenProposal/>
                        }
                    }
                }
            }
        } else {
            return (null)
        }
    }
}

const mapStateToProps = (state) => {
    return {
        memberId: state.proposal.data.memberId,
        balanceIn: state.proposal.data.balanceIn,
        balanceInToken: state.proposal.data.balanceInToken,
        voteYes: state.proposal.data.voteYes,
        voteNo: state.proposal.data.voteNo,
        allVotes: state.proposal.data.allVotes,
        minimumVotes: state.proposal.data.minimumVotes,
        isExecuted: state.proposal.data.isExecuted,
        proposalId: state.proposal.data.proposalId,
        isDeadlineOver: state.proposal.data.isDeadlineOver,
        enoughBudget: state.proposal.data.enoughBudget,
        isVoted: state.proposal.data.isVoted
    }
}

export default connect(mapStateToProps)(Proposal)

Proposal.propTypes = {
    params: PropTypes.object,
    memberId: PropTypes.string,
    authData: PropTypes.object,
    balanceIn: PropTypes.string,
    balanceInToken: PropTypes.string,
    enoughBudget:PropTypes.bool,
    voteYes:PropTypes.string,
    voteNo:PropTypes.string,
    allVotes:PropTypes.string,
    minimumVotes:PropTypes.string,
    isExecuted:PropTypes.bool,
    isDeadlineOver:PropTypes.bool,
    proposalId:PropTypes.string,
    isVoted:PropTypes.bool,
    dispatch: PropTypes.func
}


// WEBPACK FOOTER //
// ./src/layouts/proposal/Proposal.js